import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Detalles del pedido',
  sections: {
    driver_info: 'Info del repartidor',
    order_info: 'Info del pedido',
    price_info: 'Info de precios',
    adjustments: 'Ajustes',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Para llevar',
    [ORDER_METHODS.delivery]: 'Entrega',
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Servicio a la habitación',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Servicio en mesa',
  },
  room_service_location_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: {
      details_label: 'Zimmernummer',
    },
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: {
      details_label: 'Tischnummer',
    },
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'Este pedido está pendiente de aprobación',
    [FULFILLMENT_STATUSES.reviewed]: 'Este pedido está pendiente de aprobación',
    [FULFILLMENT_STATUSES.accepted]: 'Este pedido se está procesando',
    [FULFILLMENT_STATUSES.preparing]: 'Este pedido se está procesando',
    [FULFILLMENT_STATUSES.ready]: 'Este pedido está listo para ser recogido por el cliente',
    [FULFILLMENT_STATUSES.on_delivery]: 'Este pedido está siendo entregado al cliente',
    [FULFILLMENT_STATUSES.picked]: 'Este pedido se completó con éxito',
    [FULFILLMENT_STATUSES.rejected]: 'Este pedido ha sido rechazado y reembolsado',
    default: 'Este pedido se completó con éxito',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Solicitado por el cliente',
    [REFUND_REASONS.Reclamation]: 'Reclamación',
    [REFUND_REASONS.CommunicationError]: 'Error de comunicación',
    [REFUND_REASONS.Other]: 'Otro',
    [REFUND_REASONS.Dispute]: 'Disputa del cliente',
    dispute_win: 'Disputa ganada',
    null: '',
    undefined: '',
  },
  labels: {
    order_note: 'Nota del pedido',
    discount: 'Descuento',
    driver_name: 'Nombre del repartidor',
    driver_phone_number: 'Teléfono del repartidor',
    pin_code: 'PIN',
    invoice_payment: 'Pago por factura',
    paid_in_cash: 'Pago en efectivo',
    customer_paid_online: 'El cliente pagó en línea',
    phone: 'Tel',
    email: 'Email',
    points_used: 'Este pedido incluye una recompensa de puntos de fidelidad canjeada por un cliente fiel',
    delivery: 'Entrega',
    pickup: 'Recogida',
    original: 'Original',
    delivery_fee: 'Gastos de envío',
    tip: 'Propina',
    service_fee: 'Procesamiento en línea',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'Tarifa de PayPal',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Porcentaje de descuento por total aplicado',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Porcentaje de descuento por productos aplicado',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Importe de descuento por productos aplicado',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Importe de descuento por total aplicado',
      [OFFER_KIND.BOGO]: 'BOGO aplicado',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo mitad de precio aplicado',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Artículo gratis por productos aplicado',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Artículo gratis por total aplicado',
      GiftCard: 'Tarjeta regalo aplicada',
      Reward: 'Puntos de fidelidad aplicados',
      CashbackAccount: 'Puntos de fidelidad aplicados',
      PromoCodeComponent: 'Promo aplicada',
      Offer: 'Oferta aplicada',
    },
    total_discount: 'Promo aplicada',
    tax: 'Impuestos',
    total: 'Total',
    today: 'Hoy',
  },
  schedule: {
    header: 'Programado para el {{date}}, {{time}}',
    text: 'Te avisaremos cuando sea hora de empezar a preparar el pedido',
  },
};
